/**
 * Module dependencies.
 */

import { BadgePrice } from 'src/components/core/badges/badge-price';
import { Text } from 'src/components/core/text';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

/**
 * Props type.
 */

type Props = {
  className?: string;
  price: number;
};

/**
 * `Label` styled component.
 */

const Label = styled(Text).attrs({ as: 'p', variant: 'bodyXs' })`
  color: var(--color-primary);
  grid-area: vat;
  text-align: center;
`;

/**
 * Export `Pricing` component.
 */

export const Pricing = (props: Props) => {
  const { className, price } = props;
  const { t } = useTranslation();

  return (
    <BadgePrice className={className} data-variant={'secondary'}>
      <Text as={'p'} style={{ gridArea: 'price', paddingTop: 'var(--space-xxs)' }} variant={'h1'} weight={600}>
        {price}
      </Text>

      <Text as={'p'} style={{ gridArea: 'price-symbol' }} variant={'h1'} weight={600}>
        {'€'}
      </Text>

      <Label>{t('common:labels.vat')}</Label>
    </BadgePrice>
  );
};
